<template>
  <div id="app">
    <UWHeader/>
    <Main/>
	<UWFooter/>
  </div>
</template>

<script>
import Main from './components/Main.vue'
import UWHeader from './components/UWHeader.vue'
import UWFooter from './components/UWFooter.vue'

export default {
  name: 'App',
  components: {
	Main,
	UWHeader,
	UWFooter
  }
}
</script>

<style>
@font-face { 
	font-family: "Encode Sans Compressed";
	src: url("./assets/fonts/EncodeSansCondensed-800-ExtraBold.ttf"); 
}

@font-face { 
	font-family: "Encode Sans Normal Black";
	src: url("./assets/fonts/EncodeSans-Normal-Black.ttf"); 
}

@font-face { 
	font-family: "UniSansBook";
	src: url("./assets/fonts/UniSansBook.otf"); 
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  min-height:100vh;
  position:relative;
  margin-top: 0; 
}

body {
	font-family: 'Open Sans', sans-serif;
  line-height: 1.7 !important;
	margin:0;
}

.container {
	max-width:1170px;
	margin-right: auto;
	margin-left: auto;
	padding-left: 15px;
	padding-right: 15px;
	position:relative;
}

#app .header {
	text-align:left;
}

#app h1 {
	color: #4b2e83;
	font-family: "Encode Sans Compressed",sans-serif;
	font-size:3rem;
	font-weight: 300;
	line-height: 1.3;
}

#app h2 {
	color: #4b2e83;
	font-size:1.5rem;
	font-weight: 800;
  margin-bottom: 1rem;
}
#app h3 {
  /* margin: 40px 0 0; */
  font-size:1.2rem;
  font-weight: 300;
  /* padding-bottom:1rem; */
}
#app h4 {
  /* margin: 40px 0 0; */
  font-size:1.2rem;
  font-weight: 300;
  /* padding-bottom:1rem; */
}

/* Small Devices, Tablets */
@media only screen and (max-width: 767px) {
	#app h1 {
		font-size:2rem;
	}
	#app h2 {
		font-size:1.2rem;
	}
	#app h3 {
		font-size:1.1rem;
	}
}
</style>
